var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-spacer'),_c('v-col'),_c('v-col',[_c('v-row',{staticClass:"pa-0 ml-5 hidden-md-and-down",class:{
        'text-h5 ': _vm.$vuetify.breakpoint.mdAndDown,
        'text-h6': _vm.$vuetify.breakpoint.lgAndUp,
      },attrs:{"align":"center","no-gutters":""}},[_c('v-col',{staticClass:"text-left",attrs:{"cols":"12"}},[_vm._v(_vm._s(_vm.supportText))]),_c('v-col',{staticClass:"font-weight-black text-left",attrs:{"cols":"12"}},[_vm._v(_vm._s(_vm.email))]),_c('v-col',{staticClass:"font-weight-black text-left",attrs:{"cols":"12"}},[_vm._v(_vm._s(_vm.phone))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }